module.exports = __webpack_public_path__ + "static/media/KaTeX_Fraktur-Regular.a9509497.ttf";